import { HealthcareProviderType } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useHistoryPushWithBackAction } from '@dreryk/react-components';

import { getHealthcareNfzSettingsPath } from '~legacy.p1';

import { medicalDevicesTranslationKeys } from '../../translations';

import { StyledGoToNfzLink } from './GoToNfzLink.styled';

type GoToNFZSettingsLinkProps = {
   readonly healthcareProviderType: HealthcareProviderType;
};

export const GoToNFZSettingsLink = (props: GoToNFZSettingsLinkProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);
   const goToNfzSettings = (): void => {
      push(getHealthcareNfzSettingsPath(props.healthcareProviderType), {
         label: medicalDevicesTranslationKeys.goBackToVisit,
      });
   };
   return (
      <StyledGoToNfzLink
         testId={'goToNFZSettings'}
         onClick={goToNfzSettings}
         label={medicalDevicesTranslationKeys.goToNfzSettings}
      />
   );
};
